import { Node } from 'prosemirror-to-html-js';
import get from 'lodash/get';

export default class Heading extends Node {
  matching() {
    return this.node.type === "heading";
  }

  tag() {
    const level = this.node.attrs?.level || 1;
    return [
      {
        tag: `h${level}`,
        attrs: {
          style: this.getStyles()
        }
      }
    ];
  }

  getStyles() {
    let styles = '';
    if (get(this.node, 'attrs.textAlign')) {
      styles += `text-align: ${get(this.node, 'attrs.textAlign')};`;
    }
    if (get(this.node, 'attrs.indent')) {
      const indentLevel = get(this.node, 'attrs.indent');
      const indentSize = 20; // pixels per indent level
      styles += `padding-left: ${indentLevel * indentSize}px;`;
    }
    return styles;
  }
}
